type Token = {
  address: string;
  symbol: string;
  decimals: number;
};

const getWhitelistedTokens = async (): Promise<Token[]> => {
  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/token-whitelist`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    },
  );
  if (!response.ok) {
    throw new Error("Error fetching wallet activity stats");
  }

  const data = (await response.json()) as { whitelist: Token[] };

  return data.whitelist;
};

export { getWhitelistedTokens };
export type { Token };
